import * as React from "react";
import { useEffect, useRef, useState } from "react";
import { Overlay } from "ol";
import { getMap } from "../GeoLiteMap";
import { useMapContext } from "../../Contexts/MapContext";
import { replaceFieldsWithValues } from "../utils";
import "./Tooltip.scss";

export const Tooltip = (): JSX.Element => {
    const { hoveredFeature } = useMapContext();
    const [title, setTitle] = useState<string>();
    const [subtitle, setSubtitle] = useState<string>();
    const [content, setContent] = useState<string>();
    const [style, setStyle] = useState({});

    const overlayRef = useRef<Overlay>();

    useEffect(() => {
        overlayRef.current = new Overlay({
            element: document.getElementById("tooltip"),
            offset: [0, -20],
            positioning: "bottom-center",
            className: "popup-overlay"
        });
        getMap().addOverlay(overlayRef.current);
    }, []);

    useEffect(() => {
        if (hoveredFeature && hoveredFeature.evt) {
            overlayRef.current.setPosition(hoveredFeature.evt);

            const tooltipTemplate = hoveredFeature.tooltipTemplate;
            setTitle(replaceFieldsWithValues(hoveredFeature.feature, tooltipTemplate.title, hoveredFeature.fieldInfo));
            setSubtitle(
                replaceFieldsWithValues(hoveredFeature.feature, tooltipTemplate.subtitle, hoveredFeature.fieldInfo)
            );
            setContent(
                replaceFieldsWithValues(hoveredFeature.feature, tooltipTemplate.content, hoveredFeature.fieldInfo)
            );

            setStyle({
                backgroundColor: tooltipTemplate.backgroundColor || "darkgrey",
                color: tooltipTemplate.textColor || "white"
            });
        }
    }, [hoveredFeature]);

    return (
        <div id="tooltip">
            {hoveredFeature ? (
                <div className="tooltip-container">
                    <div className="tooltip-shadow">
                        <div className="tooltip-box" style={style}>
                            {title && <div className="tooltip-title" dangerouslySetInnerHTML={{ __html: title }}></div>}
                            {subtitle && (
                                <div className="tooltip-subtitle" dangerouslySetInnerHTML={{ __html: subtitle }}></div>
                            )}
                            {content && (
                                <div className="tooltip-content" dangerouslySetInnerHTML={{ __html: content }}></div>
                            )}
                        </div>
                        <div className="tooltip-shape" style={style}></div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};
